export default __webpack_public_path__ + "static/media/oladimeji.1ab43d1a.png";